import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';

export type ProgressData = {
  name: string;
  value: number;
  color?: string;
};

type ProgressBarProps = {
  progressTitle?: string;
  progressData: ProgressData[];
  showTooltip?: boolean;
};
const MultiProgressBar: React.FC<ProgressBarProps> = ({
  progressTitle,
  progressData,
  showTooltip = false,
}) => {
  return (
    <Box width="100%">
      {progressTitle && (
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 500,
            fontSize: '0.75rem',
            lineHeight: '1rem',
            color: '#6C6C6C',
            marginBottom: '0.5rem',
          }}
        >
          {progressTitle}
        </Typography>
      )}
      <Box display="flex" height={8} borderRadius={5} overflow="hidden" mb={1} gap="0.125rem">
        {progressData.map((data, index) => {
          const progressBox = (
            <Box flex={Math.abs(data.value)} bgcolor={data.color} borderRadius={0} />
          );

          return showTooltip ? (
            <Tooltip
              key={index}
              title={
                <Box display="flex" alignItems="center" gap={1}>
                  <Box width="16px" height="16px" bgcolor={data.color} borderRadius={1} />
                  <Typography
                    sx={{
                      fontWeight: 500,
                      color: '#162936',
                      fontSize: '0.875rem',
                      lineHeight: '1.25rem',
                    }}
                  >
                    {`${data.name}: ${Math.abs(data.value).toFixed(1)}%`}
                  </Typography>
                </Box>
              }
              arrow={false}
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: '#FFFFFF',
                    borderRadius: '8px',
                    color: '#162936',
                    border: '1px solid #737F86',
                    '& .MuiTooltip-arrow': {
                      color: '#6C6C6C',
                    },
                    '& .MuiTooltip-tooltip': {
                      borderRadius: '0.75rem',
                      bgcolor: '#FFF',
                      backdropFilter: 'blur(5px)',
                      border: '1px solid #737F86',
                      position: 'relative',
                      width: '200px',
                    },
                  },
                },
              }}
            >
              {progressBox}
            </Tooltip>
          ) : (
            <React.Fragment key={index}>{progressBox}</React.Fragment>
          );
        })}
      </Box>
      <Box display="flex" flexWrap="wrap">
        {progressData.map((data, index) => (
          <Typography
            key={index}
            variant="body2"
            flex={data.value < 1 ? 1 : data.value}
            sx={{
              color: data.color,
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 500,
              fontSize: '0.875rem',
              lineHeight: '1rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: '1',
              WebkitBoxOrient: 'vertical',
            }}
          >
            {data.value < 5 ? '' : `${data.value}%`}
            {index < 2 || data.name === 'Others' ? ` ${data.name} ` : ''}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default MultiProgressBar;
